import { i18n } from '../../../../../../../shared/helpers/i18n';
import { getColors } from './constants';
import { NotificationConfig, NotificationTypeId } from './types';

const NOTIFICATION_CONFIGS: Record<NotificationTypeId, () => NotificationConfig> = {
    'mute-microphone': () => ({
        id: 'mute-microphone',
        icons: [{ name: 'microOffSolid', color: getColors().iconMuted }],
        text: i18n('dtmf', 'notification.microphone-muted'),
        actions: [
            {
                label: i18n('dtmf', 'notification.turn-on'),
                command: ['1', '2'],
            },
        ],
        row: 'primary',
    }),
    'mute-camera': () => ({
        id: 'mute-camera',
        icons: [{ name: 'cameraOffSolid', color: getColors().iconMuted }],
        text: i18n('dtmf', 'notification.camera-muted'),
        actions: [
            {
                label: i18n('dtmf', 'notification.turn-on'),
                command: ['1', '7'],
            },
        ],
        row: 'primary',
    }),
    'mute-both': () => ({
        id: 'mute-both',
        icons: [
            { name: 'cameraOffSolid', color: getColors().iconMuted },
            { name: 'microOffSolid', color: getColors().iconMuted },
        ],
        text: i18n('dtmf', 'notification.camera-and-microphone-muted'),
        actions: [
            {
                label: i18n('dtmf', 'notification.turn-on-camera'),
                command: ['1', '7'],
            },
            {
                label: i18n('dtmf', 'notification.turn-on-microphone'),
                command: ['1', '2'],
            },
        ],
        row: 'primary',
    }),
    'reaction-hand': () => ({
        id: 'reaction-hand',
        icons: [{ name: 'handSolid', color: getColors().iconHand }],
        text: i18n('dtmf', 'notification.hand-raised'),
        actions: [
            {
                label: i18n('dtmf', 'notification.hand-lower'),
                command: ['1', '3'],
            },
        ],
        row: 'primary',
    }),
    'waiting-room': () => ({
        id: 'waiting-room',
        icons: [{ name: 'userGroupSolid', color: getColors().iconWaitingRoom }],
        text: i18n('dtmf', 'notification.waiting-room'),
        row: 'secondary',
    }),
    summarization: () => ({
        id: 'summarization',
        icons: [{ name: 'yaGptSolid', color: getColors().iconSummarization }],
        text: i18n('dtmf', 'notification.summarization'),
        row: 'secondary',
    }),
    recording: () => ({
        id: 'recording',
        icons: [{ name: 'recordOutlineMd', color: getColors().iconRecording }],
        text: i18n('dtmf', 'notification.recording'),
        row: 'secondary',
    }),
};

export function getNotificationConfig(id: NotificationTypeId): NotificationConfig {
    return NOTIFICATION_CONFIGS[id]();
}
